import styled from 'styled-components';

export const ReviewDate = styled.p`
  margin-bottom: 10px;
  color: ${({ theme }) => theme.color.accordionColor};
`;

export const ReviewContent = styled.p`
  margin-bottom: 10px;
  color: ${({ theme }) => theme.color.accordionColor};

  letter-spacing: 0.02em;
`;
